/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerBalancesSelfOptions,
  GetLedgerBalancesSelfResponses,
} from '../types/GetLedgerBalancesSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get your own available, locked, and borrowed assets
 * {@link /v1/ledger/balances/self}
 */
export function getLedgerBalancesSelf<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerBalancesSelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetLedgerBalancesSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/balances/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerBalancesSelfResponses, ThrowOnError>>,
  )
}
